import { _ as _applyDecoratedDescriptor, a as _initializerDefineProperty } from '../_rollupPluginBabelHelpers-3b0ba74f.js';
import Component from '@glimmer/component';
import { action, set } from '@ember/object';
import { inject } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import { task, timeout } from 'ember-concurrency';
import { paesiMondo } from '../lib/list_taxes.js';
import { beebeeAjaxGet } from '../lib/utility/ajax.js';
import '@ember/utils';
import 'moment-timezone';
import 'ember-inflector';
import getConfig from '../lib/get-config.js';
import { precompileTemplate } from '@ember/template-compilation';
import { setComponentTemplate } from '@ember/component';

var TEMPLATE = precompileTemplate("<div class=\'grid-x grid-padding-x address-sub-row\'>\n  <div class=\'cell auto\'>\n    {{#if this.isItaly}}\n      {{#if this.manualEntry}}\n        <Input\n          @type=\'text\'\n          @value={{this.item.luogo_nascita}}\n          placeholder=\'e.g. Milano\'\n          class=\'{{if this.item.errors.luogo_nascita \"error\"}}\'\n        />\n      {{else}}\n        <div class=\'{{if this.item.errors.luogo_nascita \"error\"}}\'>\n          <PowerSelect\n            @search={{perform this.searchComuneNascita}}\n            @selected={{this.selectedComuneNascita}}\n            @onChange={{this.onComuneNascitaChange}}\n            @renderInPlace={{true}}\n            @searchEnabled={{true}}\n            @placeholder={{t \'address.city.placeholder\'}}\n            @searchPlaceholder={{t \'address.comune.search.placeholder\'}}\n            @noMatchesMessage={{t \'address.comune.no.match\'}}\n            as |comune|\n          >\n            <div class=\'comune-item\'>\n              {{comune.comune}}\n              {{comune.cap}}\n              {{#if comune.code_prov}}\n                <span class=\'prov-badge\'>\n                  {{comune.code_prov}}\n                </span>\n              {{/if}}\n            </div>\n          </PowerSelect>\n        </div>\n      {{/if}}\n    {{else}}\n      <Input\n        @type=\'text\'\n        @value={{this.item.luogo_nascita}}\n        placeholder=\'e.g. Milano\'\n        class=\'{{if this.item.errors.luogo_nascita \"error\"}}\'\n      />\n    {{/if}}\n  </div>\n  <div class=\'cell auto\'>\n    <Input\n      @type=\'text\'\n      @value={{this.item.provincia_nascita}}\n      disabled={{this.isProvinciaDisabled}}\n      placeholder=\'e.g. MI\'\n    />\n  </div>\n  <div class=\'cell auto\'>\n    <div class=\'{{if this.item.errors.nazione_nascita \"error\"}}\'>\n      <PowerSelect\n        @options={{this.paesiMondo}}\n        @selected={{this.item.nazione_nascita}}\n        @onChange={{this.onNazionaNascitaChange}}\n        @searchEnabled={{true}}\n        @renderInPlace={{true}}\n        @placeholder={{t \'nation\'}}\n        as |paese|\n      >\n        {{paese}}\n      </PowerSelect>\n    </div>\n  </div>\n</div>\n{{#if this.isItaly}}\n  <div class=\'grid-x grid-padding-x\'>\n    <div class=\'cell small-12\'>\n      <small class=\'manual-entry-toggle\'>\n        <button\n          type=\'button\'\n          class=\'link-button\'\n          {{on \'click\' this.toggleManualEntry}}\n        >\n          {{if this.manualEntry (t \'address.comune.manual.search\') (t \'address.comune.manual.enter\')}}\n        </button>\n      </small>\n    </div>\n  </div>\n{{/if}}\n");

var _dec, _class, _descriptor, _descriptor2;
const DEBOUNCE_MS = 500;
let BbBirthPlacePickerComponent = (_dec = task({
  restartable: true
}), _class = class BbBirthPlacePickerComponent extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "session", _descriptor, this);
    _initializerDefineProperty(this, "manualEntry", _descriptor2, this);
    this.paesiMondo = paesiMondo;
  }
  get item() {
    return this.args.item;
  }
  get isItaly() {
    const n = (this.item?.nazione_nascita || '').toLowerCase();
    return n === 'italia' || n === 'italy';
  }
  get isProvinciaDisabled() {
    return this.isItaly && !this.manualEntry;
  }
  get selectedComuneNascita() {
    const l = this.item?.luogo_nascita;
    return l ? {
      comune: l
    } : null;
  }
  *searchComuneNascita(q) {
    yield timeout(DEBOUNCE_MS);
    if (!q || q.length < 2) return [];
    return yield beebeeAjaxGet(`${getConfig(this).APP.urlApi}/comuni_search`, this.session.token, {
      q
    });
  }
  onNazionaNascitaChange(nazione) {
    set(this.item, 'nazione_nascita', nazione || null);
    set(this.item, 'luogo_nascita', null);
    set(this.item, 'provincia_nascita', null);
    this.manualEntry = false;
  }
  onComuneNascitaChange(comune) {
    if (!comune) return;
    set(this.item, 'luogo_nascita', comune.comune);
    set(this.item, 'provincia_nascita', comune.code_prov || null);
  }
  toggleManualEntry() {
    this.manualEntry = !this.manualEntry;
    if (this.manualEntry) {
      set(this.item, 'luogo_nascita', null);
      set(this.item, 'provincia_nascita', null);
    }
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "session", [inject], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "manualEntry", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, "searchComuneNascita", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "searchComuneNascita"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onNazionaNascitaChange", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onNazionaNascitaChange"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onComuneNascitaChange", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onComuneNascitaChange"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "toggleManualEntry", [action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleManualEntry"), _class.prototype), _class);
setComponentTemplate(TEMPLATE, BbBirthPlacePickerComponent);

export { BbBirthPlacePickerComponent as default };
//# sourceMappingURL=bb-birth-place-picker.js.map
